import { countries } from 'country-data'
import { FormLabel, FormControl, FormGroup } from 'react-bootstrap'
import React, { PureComponent } from 'react'
import { DatePicker } from '../common/datepicker'
import TextFieldFormGroup from '../common/form/text_field_form_group'
import moment from 'moment'
import validator from 'validator'

const validationStateError = 'error'
const validationStateSuccess = 'success'

const regexp = /^[\d\-+]+$/
const alphaNumericWithSpaceAndDashRegexp = /^[\w-() ]+$/

const isValidDate = (date) => (!date ? true : moment(date, 'YYYY-MM-DD', true).isValid())

class DocumentInformationStep extends PureComponent {
  state = {
    passport_number: '',
    drivers_license: '',
    country_code: '',
    selected_country_code: '',
    identityDocuments: {},
  }

  componentDidMount() {
    const { props } = this
    const { data } = props
    let className
    const identityDocuments = { ...props.identityDocuments }
    Object.entries(identityDocuments).forEach(([key, entity]) => {
      if (entity.identity_data_source) {
        for (const item of entity.identity_data_source) {
          if (
            item.raw_data &&
            item.raw_data.Classification &&
            item.raw_data.Classification &&
            item.raw_data.Classification.Type &&
            item.raw_data.Classification.Type.ClassName
          ) {
            if (item.raw_data.Classification.Type.ClassName !== 'Unknown') {
              className = item.raw_data.Classification.Type.Name
            }
          }
        }
      }
    })

    this.setState(
      {
        drivers_license: data.drivers_license || '',
        passport_number: data.passport_number || '',
        country_code: data.country_code || '',
        identityDocuments: props.identityDocuments || {},
        selected_country_code: data.selected_country_code || '',
        className,
      },
      () => this.props.setValidationState(this.isValidForm())
    )
    if (className) {
      this.props.setValidationState(true)
    } else {
      const genericTypesId = props.genericTypes.map((i) => i.id)
      const result = Object.entries(props.identityDocuments).some(([guid, entity], i) =>
        genericTypesId.includes(entity.document_classification)
      )
      if (!result) {
        this.props.setValidationState(result)
      }
    }
  }

  passportNumberValidationState = () => {
    if (!this.state.passport_number && !this.state.drivers_license) return validationStateError

    if (this.state.passport_number) {
      const result = validator.matches(this.state.passport_number, alphaNumericWithSpaceAndDashRegexp)
      return result ? validationStateSuccess : validationStateError
    }
    return null
  }

  driversLicenseValidationState = () => {
    if (!this.state.passport_number && !this.state.drivers_license) return validationStateError

    if (this.state.drivers_license) {
      return validationStateSuccess
    }
    return null
  }

  isValidForm = () => {
    const id = Object.keys(this.state.identityDocuments)[0]
    const result =
      this.passportNumberValidationState() !== validationStateError &&
      this.driversLicenseValidationState() !== validationStateError &&
      this.countryValidationState() !== validationStateError &&
      this.genericTypeValidationState(id) !== validationStateError
    return result
  }

  countryValidationState = () => {
    if (this.state.country_code && this.state.country_code !== '') {
      return validationStateSuccess
    }
    return validationStateError
  }

  genericTypeValidationState = (id) => {
    if (Object.keys(this.state.identityDocuments).length === 0) {
      return true
    }
    if (this.state.className) {
      return validationStateSuccess
    }
    if (
      this.state.identityDocuments[id].document_classification &&
      this.state.identityDocuments[id].document_classification !== '00000000-0000-0000-0000-000000000000'
    ) {
      return validationStateSuccess
    }
    return validationStateError
  }

  handleInputChange = (e) => {
    const values = {
      passport_number: this.state.passport_number,
      drivers_license: this.state.drivers_license,
      country_code: this.state.country_code,
      identityDocuments: JSON.parse(JSON.stringify(this.state.identityDocuments)),
    }
    const updatedValues = { ...values, [e.target.name]: e.target.value }
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.props.handleChange('documentInformationStep', 'transactionIdentity', updatedValues, this.isValidForm())
    })
  }

  handleDateChange = (id) => (date) => {
    const { state } = this
    const { identityDocuments } = state
    if ((date.length > 10 || !regexp.test(date)) && date !== '') {
      return date
    }

    if (identityDocuments[id].expiration_date !== date) {
      const entities = { ...identityDocuments }
      entities[id] = {
        ...entities[id],
        expiration_date: moment(date).format('YYYY-MM-DD'),
      }
      this.setState({ identityDocuments: entities }, () =>
        this.props.handleChange('documentInformationStep', 'identityDocuments', entities, this.isValidForm())
      )
    }
  }

  onCanBypassChange =
    (id) =>
    ({ currentTarget }) => {
      const { state } = this
      const { identityDocuments } = state
      const entities = { ...identityDocuments }
      entities[id] = {
        ...entities[id],
        can_bypass_expiration: currentTarget.checked,
      }
      this.setState({ identityDocuments: entities }, () =>
        this.props.handleChange('documentInformationStep', 'identityDocuments', entities, this.isValidForm())
      )
    }

  handleGenericDocumentTypeChange =
    (id) =>
    async ({ currentTarget }) => {
      const { state } = this
      const { identityDocuments } = state
      const entities = { ...identityDocuments }
      entities[id] = {
        ...entities[id],
        document_classification: currentTarget.value,
      }
      this.setState({ identityDocuments: entities }, () =>
        this.props.handleChange('documentInformationStep', 'identityDocuments', entities, this.isValidForm())
      )
    }

  render() {
    const { state, props } = this
    const { genericTypes } = props
    const { identityDocuments } = state
    const currentYear = new Date().getFullYear()

    return (
      <div className='document-information-step'>
        <h2 className='text-center'>Document Information</h2>
        <div className='row'>
          <div className='col-md-4'>
            <TextFieldFormGroup
              help=''
              autoFocus
              value={state.drivers_license}
              controlId='drivers_license'
              name='drivers_license'
              placeholder='Driver License/Government ID'
              controlLabel='Driver License/Government ID'
              validationState={this.driversLicenseValidationState()}
              handleFieldChange={this.handleInputChange}
            />
          </div>
          <div className='col-md-4'>
            <TextFieldFormGroup
              placeholder='Passport Number'
              help='Alphanumeric characters'
              value={state.passport_number}
              controlId='passport_number'
              name='passport_number'
              controlLabel='Passport Number'
              validationState={this.passportNumberValidationState()}
              handleFieldChange={this.handleInputChange}
            />
          </div>
          <div className='col-md-4'>
            <FormGroup controlId={'country_code'}>
              <FormLabel>Document Country</FormLabel>
              <FormControl
                name={'country_code'}
                value={state.country_code}
                as='select'
                placeholder='select'
                onChange={this.handleInputChange}
                isInvalid={this.countryValidationState() === 'error'}
              >
                <option key={'select'} value={''} defaultValue={''} disabled>
                  Select
                </option>
                {countries.all.map((item, i) => (
                  <option key={i} value={item['alpha2']}>{`${item['alpha2']} - ${item['name']}`}</option>
                ))}
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </div>
        </div>
        {Object.keys(identityDocuments).map((id, index) => {
          return (
            <div className='row' key={index}>
              <div className='col-md-4'>
                <div className={`form-group ${isValidDate(identityDocuments[id].expiration_date) ? '' : 'has-error'}`}>
                  <label htmlFor='expiration_date' className='control-label'>
                    Expiration Date
                  </label>
                  {(state.country_code === 'JP' || state.selected_country_code === 'JP') && (
                    <div className='m-b-xs'>
                      <a
                        href='https://en.wikipedia.org/wiki/Driving_license_in_Japan'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Japan Driving License Expiration Reference
                      </a>
                    </div>
                  )}
                  <DatePicker
                    validation={true}
                    value={identityDocuments[id].expiration_date}
                    onChange={this.handleDateChange(id)}
                    max={currentYear + 100}
                    min={currentYear}
                  />
                </div>
              </div>
              <div className='col-md-4'>
                <div className='form-group'>
                  {state.className && (
                    <>
                      <label htmlFor='can_bypass_expiration' className='control-label'>
                        Type
                      </label>
                      <span className='form-control input-md'>{state.className}</span>
                    </>
                  )}
                  {!state.className && (
                    <>
                      <FormGroup controlId={'generic_types'}>
                        <FormLabel>Generic Types</FormLabel>
                        <FormControl
                          name={'generic_types'}
                          value={identityDocuments[id].document_classification || ''}
                          as='select'
                          placeholder='select'
                          onChange={this.handleGenericDocumentTypeChange(id)}
                          isInvalid={this.genericTypeValidationState(id) === 'error'}
                        >
                          <option value='' />
                          {genericTypes.map((g, i) => (
                            <option key={i} value={g.id}>
                              {g.document_name}
                            </option>
                          ))}
                        </FormControl>
                        <FormControl.Feedback />
                      </FormGroup>

                      {/*<label htmlFor='can_bypass_expiration' className='control-label'>*/}
                      {/*  Generic Types*/}
                      {/*</label>*/}
                      {/*<select*/}
                      {/*  value={identityDocuments[id].document_classification || ''}*/}
                      {/*  className='form-control input-md'*/}
                      {/*  onChange={this.handleGenericDocumentTypeChange(id)}*/}
                      {/*>*/}
                      {/*  <option value='' />*/}
                      {/*  {genericTypes.map((g, i) => (*/}
                      {/*    <option key={i} value={g.id}>*/}
                      {/*      {g.document_name}*/}
                      {/*    </option>*/}
                      {/*  ))}*/}
                      {/*</select>*/}
                    </>
                  )}
                </div>
              </div>
              <div className='col-md-4'>
                <div className='form-check'>
                  <label htmlFor='can_bypass_expiration' className='form-check-label'>
                    Can Bypass Expiration
                  </label>
                  <input
                    id={'can_bypass_expiration'}
                    name={'can_bypass_expiration'}
                    className='form-check-input'
                    type={'checkbox'}
                    checked={identityDocuments[id].can_bypass_expiration}
                    onChange={this.onCanBypassChange(id)}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default DocumentInformationStep
